import { createFileRoute } from "@tanstack/react-router";
import CitiesHub from "@/pages/CitiesHub";
import { routeHead } from "@/lib/seo/route-head";
import { listingsV2QueryOptions } from "@/lib/queries/publicData";

export const Route = createFileRoute("/masini-orase/")({
  head: () => routeHead("/masini-orase/"),
  // Prefetch city counts so the hub renders its city links server-side.
  loader: async ({ context }) => {
    const cityHubRows = await context.queryClient
      .ensureQueryData(listingsV2QueryOptions({ country_code: 'RO', limit: 2000 }))
      .catch(() => undefined);
    return { cityHubRows };
  },
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <CitiesHub />
  );
}
